import { ErrorHandler, Inject, Injectable, Injector } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'
import { BOOTSTRAP_DATA } from 'api/providers'
import { Logger } from 'common/log'
import { BootstrapData } from 'elements-sdk/src'
import { ErrorModalComponent } from 'common/util/components/errorModal.component'
import { NotifyService } from 'common/util/services/notify.service'
import { PanelService } from 'panel/services/panel.service'
const NOTIFICATION_THROTTLE = 2000

@Injectable({ providedIn: 'root' })
export class AngularErrorHandler implements ErrorHandler {
  logger = new Logger(__filename)

  constructor (
    private injector: Injector,
    @Inject(BOOTSTRAP_DATA) public bootstrapData: BootstrapData,
  ) { }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  handleError (error: any): void {
    if (!this.bootstrapData.debug) {
      this.logger.warn(error)
      return
    }
    this.injector.get(ErrorHandlerService).handleException(error)
  }
}

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  logger = new Logger(__filename)
  lastErrorNotification = 0

  constructor (
    private translate: TranslateService,
    private panel: PanelService,
    private notify: NotifyService,
    private ngbModal: NgbModal,
  ) { }

  handleException (exception: Error, cause?: Error): void {
    if (exception.toString().startsWith('Possibly unhandled rejection')) {
      // eslint-disable-next-line prefer-rest-params
      this.logger.warn(...arguments)
      return
    }

    this.logger.error('Unhandled exception occured')
    if (cause) {
      this.logger.error(cause)
    }
    // eslint-disable-next-line prefer-rest-params
    this.logger.error(...arguments)

    if (exception.toString().includes('ExpressionChangedAfterItHasBeenCheckedError')) {
      return
    }

    let report = '# Exception\n\n'
    report += `${exception.toString()}\n`
    report += '\n# Metadata\n\n'
    report += ` * Time: ${new Date()}\n`
    report += ` * URL: ${location.href}\n`
    report += '\n# Stack\n\n'
    report += `${exception.stack}\n`

    if (Date.now() - this.lastErrorNotification > NOTIFICATION_THROTTLE) {
      this.lastErrorNotification = Date.now()
      if (!this.panel.active) {
        this.notify.custom(
          'warning',
          this.translate.instant('An error occured'),
          this.translate.instant('Click to show details'),
          {
            click: () => {
              const modal = this.ngbModal.open(ErrorModalComponent)
              modal.componentInstance.report = report
              modal.result.catch(() => null)
            },
          },
        )
      }
    }
  }
}
